import React, { useRef, useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { postData } from "../global/Globalapi";
import axiosClient from "../global/Globalapi";
import emailjs from "@emailjs/browser";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    countryCode: "+1",
    phone: "",
    location: "",
    lookingFor: "",
    requirements: "",
    
    acceptTerms: false,
  });
  const baseURL = axiosClient?.defaults?.baseURL || "";
  const formRef = useRef(null);

  
  const [floatingStyle, setFloatingStyle] = useState({
    position: "fixed",
    bottom: "24px",
    right: "24px",
  });
  

const generateCaptcha = () => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let result = "";
  for (let i = 0; i < 5; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

const [captcha, setCaptcha] = useState("");
const [captchaInput, setCaptchaInput] = useState("");
const [captchaError, setCaptchaError] = useState("");

useEffect(() => {
  setCaptcha(generateCaptcha());
}, []);

const refreshCaptcha = () => {
  setCaptcha(generateCaptcha());
  setCaptchaInput("");
  setCaptchaError("");
};

const validateCaptcha = () => {
  if (captchaInput !== captcha) {
    setCaptchaError("Invalid CAPTCHA");
    return false;
  }
  setCaptchaError("");
  return true;
};


  useEffect(() => {
    
    const updateFloatingButton = () => {
      
      const isMobile = typeof window !== "undefined" && window.innerWidth < 1024; 
      if (!isMobile) {
        
        setFloatingStyle({ position: "fixed", bottom: "24px", right: "24px" });
        return;
      }

      const footer = document.querySelector("footer");
      if (!footer) {
       
        setFloatingStyle({ position: "fixed", bottom: "24px", right: "24px" });
        return;
      }

      const rect = footer.getBoundingClientRect();

      
      if (rect.top < window.innerHeight) {
       
        const visibleFooterHeight = Math.max(window.innerHeight - rect.top, 0);
        
        const bottomValue = visibleFooterHeight + 16;
        setFloatingStyle({
          position: "fixed",
          bottom: `${bottomValue}px`,
          right: "24px",
        });
      } else {
       
        setFloatingStyle({ position: "fixed", bottom: "24px", right: "24px" });
      }
    };

  
    updateFloatingButton();
    window.addEventListener("scroll", updateFloatingButton, { passive: true });
    window.addEventListener("resize", updateFloatingButton);

   
    return () => {
      window.removeEventListener("scroll", updateFloatingButton);
      window.removeEventListener("resize", updateFloatingButton);
    };
  }, []);
  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateCaptcha()) return;
    emailjs
      .sendForm(
        "dheeramapparels@gmail.com",
        "template_psrghbm",
        formRef.current,
        "s_MB2cl5ZRcUp158D"
      )
      .then(
        (result) => {
          console.log("Email Sent Successfully", result.text);
          alert("Email Sent Successfully");
        },
        (error) => {
          console.error("Email Not Sent: ", error);
          alert("Error Sending Email");
        }
      );

    try {
      const insertRes = await postData(baseURL + "/insert-query", {
        formData,
      });

      if (insertRes.status === 200) {
        console.log("Data INSERTED Sucessfully !...");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="bg-[#f6ae1b] relative">
      <div className="max-w-7xl mx-auto px-6 py-32 ">
        <h1 className="text-center text-5xl font-black mb-20">
          Always There For You
        </h1>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
          {/* LEFT FORM */}
          <div className="lg:col-span-2">
            <form ref={formRef} onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <label className="block text-sm font-semibold text-gray-800 mb-1">
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Enter your first name"
                    className="w-full border-b border-gray-300 focus:border-black outline-none p-2 placeholder-gray-400 rounded"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-800 mb-1 ">
                    Last Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Enter your last name"
                    className="w-full border-b border-gray-300 focus:border-black outline-none p-2 rounded placeholder-gray-400"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-800 mb-1">
                    Business Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Business Email Only"
                    className="w-full border-b border-gray-300 focus:border-black outline-none p-2 rounded placeholder-gray-400"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-800 mb-1">
                    Phone Number <span className="text-red-500">*</span>
                  </label>
                  <div className="flex border-b border-gray-300 focus-within:border-black">
                    <select
                      name="countryCode"
                      value={formData.countryCode}
                      onChange={handleChange}
                      className="outline-none bg-[#311c0e] rounded-l pr-2 text-white font-bold"
                    >
                      <option value="+91">IN +91</option>
                      <option value="+1">CA +1</option>
                      <option value="+44">UK +44</option>
                      <option value="+61">AU +61</option>
                    </select>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Enter phone number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full outline-none p-2 rounded placeholder-gray-400"
                    />
                  </div>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-800 mb-1">
                    Location <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    placeholder="Enter your location"
                    className="w-full border-b border-gray-300 focus:border-black outline-none p-2 rounded placeholder-gray-400"
                    required
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">
                  I am looking for <span className="text-red-500">*</span>
                </label>
                <select
                  name="lookingFor"
                  value={formData.lookingFor}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 outline-none"
                  required
                >
                  <option value="">Please Select</option>
                  <option value="service1">Support</option>
                  <option value="service2">Partnership</option>
                  <option value="service3">Other</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">
                  Please provide a brief overview of your requirements{" "}
                  <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="requirements"
                  value={formData.requirements}
                  onChange={handleChange}
                  placeholder="Enter your requirements here..."
                  rows="4"
                  className="w-full border border-gray-300 rounded px-3 py-2 outline-none"
                  required
                />
              </div>
   
<div className="mt-6">
  <label className="block text-sm font-semibold text-black mb-2">
    ENTER THE CAPTCHA:
  </label>

  <div className="flex items-center gap-3 mb-3">
    <div
      className="bg-blue-600 text-white px-4 py-2 rounded-md font-mono text-lg tracking-wider select-none"
      onCopy={(e) => e.preventDefault()}
    >
      {captcha}
    </div>

    <button
      type="button"
      onClick={refreshCaptcha}
      className="text-blue-700 text-xl hover:rotate-180 transition-transform"
      title="Refresh Captcha"
    >
      ⟳
    </button>
  </div>

  <input
    type="text"
    placeholder="ENTER CAPTCHA"
    value={captchaInput}
    onChange={(e) => setCaptchaInput(e.target.value.toUpperCase())}
    className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
    required
  />

  {captchaError && (
    <p className="text-red-600 text-sm mt-2">{captchaError}</p>
  )}
</div>


              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="acceptTerms"
                  checked={formData.acceptTerms}
                  onChange={handleChange}
                  required
                />
                <label className="text-sm text-gray-700">
                  I accept the privacy and terms.
                </label>
              </div>
              <button
                type="submit"
                className="bg-blue-700 text-white px-6 py-3 rounded w-full hover:bg-gray-800 text-lg font-medium"
              >
                Submit Request
              </button>
            </form>
          </div>

          
          <div className="hidden lg:flex bg-[#311c0e] text-white p-8 rounded-md shadow-md flex-col justify-between sticky top-20 h-fit">
            <div>
              <h2 className="text-lg font-bold mb-3">Get In Touch</h2>
              <p className="mb-6 text-sm text-gray-300">
                DHEERAM APPAREL CREATIONS <br /><br /> <p>– Where style meets speed, delivering quality finds</p>
                right to your door.
              </p>

              <h3 className="text-md font-semibold mb-2">Quick Contact</h3>
              <p className="text-sm">Email: info@Dheeram.com</p>
              <p className="text-sm mb-6">Support: 00 0000 000 0000</p>
            </div>
            <a
              href="https://wa.me/9840617877 "
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-green-500 text-white text-sm font-semibold px-6 py-3 rounded-lg shadow-md hover:bg-green-600 transition  duration-300"
            >
              <FaWhatsapp size={20} />
              Contact Us on WhatsApp
            </a>
          </div>
        </div>
      </div>

     
      <a
        href="https://wa.me/9840617877  "
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact on WhatsApp"
        className="lg:hidden z-50 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition"
        style={floatingStyle}
      >
        <FaWhatsapp size={28} />
      </a>
    </div>
  );
};

export default ContactPage;
